<template>
    <div class="help">
        <p class="step">步骤1</p>
        <p>将文档发送至您的手机微信或手机QQ中</p>
        <p>（仅支持Word和Excel格式）</p>
        <p class="step">步骤2</p>
        <p>在手机上，打开文档，点击右上角“···”</p>
        <p><img src="../assets/step1.png"/></p>
        <p class="step">步骤3</p>
        <p>点击【用其他应用打开】</p>
        <p><img src="../assets/step2.png"/></p>
        <p class="step">步骤4</p>
        <p>点击【存储到文件】</p>
        <p><img src="../assets/step3.png"/></p>
        <p class="step">步骤5</p>
        <p>点击右上角【存储】</p>
        <p><img src="../assets/step4.png"/></p>
        <p class="step">步骤7</p>
        <p>在上传题库页面，点击上传按钮，即可选择文件上传</p>
    </div>
</template>
<script>
export default {
    name: 'help',
    mounted() {
        document.title = '上传教程'
    }
}
</script>
<style lang="less">
.help{
    padding: 0 16px;
    padding-bottom: 16px;
}
p{
    color: #333;
    text-align: center;
    img{
        width: 80%;
        margin-top: 20px;
    }
}
.step{
    font-size: 16px;
    font-weight: bold;
    padding: 16px 0;
}
</style>